<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 6V18M8 18L5 15M8 18L11 15M16 18V6M16 6L19 9M16 6L13 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
